import { ConfigProvider, Flex, theme } from 'antd'
import { useMemo } from 'react'
import { LoadingCard } from './LoadingCard.tsx'
import { useDarkMode } from '../../hooks/useDarkMode.tsx'
import { getAntdTheme } from '../../theme/antdTheme.ts'

const { useToken } = theme

const LoadingScreen = () => {
    const { token } = useToken()

    return (<>
        <Flex
            justify='center'
            align='center'
            style={{
                width: '100vw',
                height: '100vh',
                background: token.colorBgLayout
            }}
        >
            <LoadingCard
                title='Please wait, MoneyFlow is on the case...'
                alt='App is loading...'
            />
        </Flex>
    </>)
}

// Rendered before LayoutComponent (while the user loads), so it needs its own themed provider
export const LoadingComponent = () => {
    const { darkModeEnabled } = useDarkMode()
    const themeConfig = useMemo(() => getAntdTheme(darkModeEnabled), [darkModeEnabled])

    return (
        <ConfigProvider theme={themeConfig}>
            <LoadingScreen />
        </ConfigProvider>
    )
}
